import { colors } from '@material-ui/core';

export default {
  styleOverrides: {
    root: {
      backgroundColor: colors.grey[50],
    },
  },
};
